module.exports = __webpack_public_path__ + "static/alexander-mcqueen-5ebd7344e36c33f789c38ec56756af1d.jpg";